import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'

import { AsiakkaanTuote, LaskunTyypit } from '@lemon/core-firebase/model/lasku'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { AlvService } from '../../_jaettu-angular/service/alv.service'

import { TuoteDialogiService } from './tuote-dialogi.service'
import { annaNaytettavaTuote, NaytettavaTuote } from './tuoterekisteri-logiikka'
import { TuotteetFirestoreDataSource } from './tuotteet.firestore.datasource'

import { Observable, combineLatest, from } from 'rxjs'
import { map } from 'rxjs/operators'

export type TuoteProperties = 'nimi' | 'yksikko' | 'hinta' | 'hintaVerollinen' | 'alv' | undefined

@Component({
  selector: 'app-tuotteet',
  templateUrl: './tuotteet.component.html',
  styleUrls: ['./tuotteet.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TuotteetComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) _paginator: MatPaginator
  @ViewChild(MatSort, { static: true }) _sort: MatSort

  propertiesToDisplay: TuoteProperties[] = ['nimi', 'yksikko', 'hinta', 'hintaVerollinen', 'alv']
  hakuAvoinna = false

  naytaEiYhtaanObservable: Observable<boolean>
  naytettavatTuotteetObservable: Observable<NaytettavaTuote[]>
  lataaObservable: Observable<boolean>

  dataSource: TuotteetFirestoreDataSource

  constructor(
    private _dataSource: TuotteetFirestoreDataSource,
    private _alvService: AlvService,
    private _currencyService: CurrencyService,
    private _tuoteDialogiService: TuoteDialogiService,
  ) {
    this.dataSource = this._dataSource
    this.lataaObservable = this._dataSource.lataaObservable
    const kotimaanAlvtObservable = from(this._alvService.annaLaskutyypinAlvt(LaskunTyypit.TAVALLINEN, null))
    this.naytettavatTuotteetObservable = combineLatest([this._dataSource.asiakkaanTuotteetObservable, kotimaanAlvtObservable]).pipe(
      map(([tuotteet, kotimaanAlvt]) => tuotteet.map(tuote => annaNaytettavaTuote(tuote, kotimaanAlvt, this._currencyService))),
    )
    this.naytaEiYhtaanObservable = combineLatest([this._dataSource.rivienMaaraObservable, this._dataSource.lataaObservable]).pipe(
      map(([rivienMaara, lataa]) => {
        if (lataa) {
          return false
        }
        return rivienMaara < 1
      }),
    )
  }

  ngOnInit() {
    const currentSort = this._dataSource.getSort()
    this._sort.sort({
      id: currentSort.active,
      disableClear: true,
      start: currentSort.direction === 'asc' ? 'asc' : 'desc',
    })
    this._sort.sortChange.subscribe(sort => {
      this._dataSource.changeSort(sort)
    })

    this._paginator.page.subscribe(page => {
      this._dataSource.changePage(page)
    })
  }

  avaaHaku() {
    this.hakuAvoinna = true
  }

  suljeHaku() {
    this.hakuAvoinna = false
  }

  muokkaa(tuote: AsiakkaanTuote) {
    this._tuoteDialogiService.avaaTuoterekisterinTuote(tuote)
  }

  lisaa() {
    this._tuoteDialogiService.avaaTuoterekisterinTuote(null)
  }
}
